// employees_ero_favourites

import QueryEmployeeErosFavouritesBookings from 'graphql/queries/QueryEmployeeErosFavouritesBookings'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchEmployeeErosFavouritesBookings {
	
	static fetchAll( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'employees_ero_favourites', QueryEmployeeErosFavouritesBookings, {
			variables,
			resultPath: [ 'employees_ero_favourites' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}
